/* VivaCarte Luxe — interactions */
const VC = {
  /* ── Live greeting preview (product page) ── */
  state: { greeting: '', style: 'ink', custom: false, envelope: 'None', qty: 1 },

  setGreeting(el, text) {
    document.querySelectorAll('.chips [data-greet]').forEach(c => c.classList.remove('on'));
    if (el) el.classList.add('on');
    this.state.greeting = text;
    this.state.custom = (text === '__custom__');
    const box = document.getElementById('custom-box');
    if (box) box.style.display = this.state.custom ? 'block' : 'none';
    this.renderGreeting(this.state.custom ? (document.getElementById('custom-input')?.value || '') : text);
    const lbl = document.getElementById('greet-current');
    if (lbl) lbl.textContent = this.state.custom ? 'Your own words' : (text || 'Blank');
  },
  onCustomType(val) {
    if (this.state.custom) this.renderGreeting(val);
  },
  renderGreeting(text) {
    const live = document.getElementById('greet-live');
    if (!live) return;
    live.classList.add('fading');
    setTimeout(() => {
      live.textContent = (text === 'Blank' || text === '') ? '' : text;
      live.classList.remove('fading');
    }, 220);
  },
  setStyle(el, style) {
    document.querySelectorAll('.style-toggle button').forEach(b => b.classList.remove('on'));
    el.classList.add('on');
    this.state.style = style;
    const live = document.getElementById('greet-live');
    if (live) live.classList.toggle('gold', style === 'gold');
    const lbl = document.getElementById('style-current');
    if (lbl) lbl.textContent = style === 'gold' ? 'Gold emboss' : 'Forest ink';
  },
  setEnvelope(el, name) {
    document.querySelectorAll('.env-row .env-sw, .env-row .env-none').forEach(s => s.classList.remove('on'));
    el.classList.add('on');
    this.state.envelope = name;
    const lbl = document.getElementById('env-current');
    if (lbl) lbl.textContent = name === 'None' ? 'Card only' : name + ' envelope';
  },
  qtyChange(delta) {
    const inp = document.getElementById('qty-input');
    if (!inp) return;
    let v = Math.max(1, (parseInt(inp.value) || 1) + delta);
    inp.value = v; this.state.qty = v;
  },

  /* ── Add to cart with personalisation properties ── */
  addToCart(e) {
    e.preventDefault();
    const vid = document.getElementById('selected-variant');
    if (!vid) return;
    const props = {};
    const g = this.state.custom
      ? (document.getElementById('custom-input')?.value || '').trim()
      : this.state.greeting;
    if (g && g !== 'Blank') props['Greeting'] = g;
    if (g && g !== 'Blank') props['Greeting Style'] = this.state.style === 'gold' ? 'Gold emboss' : 'Forest ink';
    if (this.state.envelope && this.state.envelope !== 'None') props['Envelope'] = this.state.envelope;
    const note = document.getElementById('gift-note');
    if (note && note.value.trim()) props['Gift Note'] = note.value.trim();

    const btn = document.getElementById('atc-btn');
    if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(vid.value), quantity: this.state.qty || 1, properties: props })
    })
      .then(r => { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(() => {
        if (btn) { btn.textContent = '✦ Added to Cart'; }
        setTimeout(() => { if (btn) { btn.textContent = 'Add to Cart'; btn.disabled = false; } }, 2200);
        VC.openCart();
      })
      .catch(err => { console.error(err); if (btn) { btn.textContent = 'Add to Cart'; btn.disabled = false; } });
  },

  selectVariant(el, pos, val) {
    el.closest('.chips').querySelectorAll('.chip').forEach(b => b.classList.remove('on'));
    el.classList.add('on');
    if (!window._sel) window._sel = {};
    window._sel[pos] = val;
    if (window._variants) {
      const match = window._variants.find(v =>
        (!window._sel[1] || v.option1 === window._sel[1]) &&
        (!window._sel[2] || v.option2 === window._sel[2]) &&
        (!window._sel[3] || v.option3 === window._sel[3]));
      if (match) {
        const vid = document.getElementById('selected-variant');
        const price = document.getElementById('pi-price-val');
        if (vid) vid.value = match.id;
        if (price) price.textContent = VC.money(match.price);
        const btn = document.getElementById('atc-btn');
        if (btn) { btn.disabled = !match.available; btn.textContent = match.available ? 'Add to Cart' : 'Sold Out'; }
        if (match.featured_image && match.featured_image.src) {
          const main = document.getElementById('stage-img');
          if (main) main.src = match.featured_image.src;
        }
      }
    }
  },
  swapImage(el, src) {
    const main = document.getElementById('stage-img');
    if (main) main.src = src;
    document.querySelectorAll('.thumb').forEach(t => t.classList.remove('on'));
    el.classList.add('on');
  },

  money(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  },

  /* ── Cart drawer ── */
  openCart() {
    const d = document.getElementById('drawer'); if (!d) return;
    d.classList.add('open'); d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    this.loadCart();
  },
  closeCart() {
    const d = document.getElementById('drawer'); if (!d) return;
    d.classList.remove('open'); d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  },
  loadCart() {
    fetch('/cart.js').then(r => r.json()).then(cart => {
      const body = document.getElementById('dw-body');
      const total = document.getElementById('dw-total');
      if (!body) return;
      if (!cart.items.length) {
        body.innerHTML = '<p style="font-size:12.5px;color:#8A8178;text-align:center;padding:48px 0;">Your cart is empty.<br><span style="font-family:\'Cormorant Garamond\',serif;font-style:italic;font-size:16px;color:#1A3328;">Every occasion deserves a card worth keeping.</span></p>';
        if (total) total.textContent = '₹0';
      } else {
        body.innerHTML = cart.items.map(it => {
          const props = Object.entries(it.properties || {})
            .filter(([k, v]) => v && k.charAt(0) !== '_')
            .map(([k, v]) => k + ': ' + v).join('<br>');
          return '<div class="dw-item">'
            + '<div class="dw-img">' + (it.image ? '<img src="' + it.image + '" alt="" loading="lazy">' : '') + '</div>'
            + '<div><p class="dw-n">' + it.product_title + '</p>'
            + (it.variant_title && it.variant_title !== 'Default Title' ? '<p class="dw-v">' + it.variant_title + '</p>' : '')
            + (props ? '<p class="dw-v">' + props + '</p>' : '')
            + '<p class="dw-p">' + VC.money(it.final_line_price) + (it.quantity > 1 ? ' <span style="font-family:\'DM Sans\';font-size:10px;color:#8A8178;">× ' + it.quantity + '</span>' : '') + '</p>'
            + '</div></div>';
        }).join('');
        if (total) total.textContent = VC.money(cart.total_price);
      }
      VC.badge(cart.item_count);
    }).catch(console.error);
  },
  badge(n) {
    let c = document.querySelector('.cart-count');
    const btn = document.querySelector('.cart-btn');
    if (n > 0) {
      if (!c && btn) { c = document.createElement('span'); c.className = 'cart-count'; btn.appendChild(c); }
      if (c) c.textContent = n;
    } else if (c) c.remove();
  },

  /* ── Home builder tabs ── */
  switchTab(id) {
    document.querySelectorAll('.tab').forEach(t => t.classList.toggle('on', t.dataset.tab === id));
    document.querySelectorAll('.tabc').forEach(c => c.classList.toggle('on', c.id === 'tc-' + id));
  },
  pickOpt(el, group, val) {
    el.closest('.optgrid').querySelectorAll('.opt').forEach(o => o.classList.remove('on'));
    el.classList.add('on');
    const p = document.getElementById('sel-' + group);
    if (p) p.textContent = val;
    if (!window._build) window._build = {};
    window._build[group] = val;
  },
  pickSwatch(el, name) {
    el.closest('.swatches').querySelectorAll('.swatch').forEach(s => s.classList.remove('on'));
    el.classList.add('on');
    const ep = document.getElementById('env-prev');
    const et = document.getElementById('sel-envelope');
    if (ep) ep.style.background = getComputedStyle(el).backgroundColor;
    if (et) et.textContent = name + ' envelope';
    if (!window._build) window._build = {};
    window._build.envelope = name;
  },

  /* ── Accordions ── */
  acc(btn) { btn.closest('.acc-item').classList.toggle('open'); },

  /* ── Mobile nav ── */
  openMenu() { const n = document.getElementById('mnav'); if (n) { n.classList.add('open'); n.setAttribute('aria-hidden','false'); document.body.style.overflow = 'hidden'; } },
  closeMenu() { const n = document.getElementById('mnav'); if (n) { n.classList.remove('open'); n.setAttribute('aria-hidden','true'); document.body.style.overflow = ''; } },

  /* ── Hero greeting cycler ── */
  heroCycle() {
    const el = document.getElementById('mock-greet');
    if (!el) return;
    const greets = ['Happy Birthday','Shubh Vivah','With Deepest Sympathy','Thank You, Truly','Happy Raksha Bandhan','A Bright New Year','With Love, Always'];
    let i = 0;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    setInterval(() => {
      el.classList.add('fade');
      setTimeout(() => { i = (i + 1) % greets.length; el.textContent = greets[i]; el.classList.remove('fade'); }, 450);
    }, 3200);
  },

  /* ── Scroll reveal ── */
  reveals() {
    const els = document.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(e => e.classList.add('in')); return; }
    const io = new IntersectionObserver(entries => {
      entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    els.forEach(e => io.observe(e));
  },

  init() {
    fetch('/cart.js').then(r => r.json()).then(c => VC.badge(c.item_count)).catch(() => {});
    document.addEventListener('keydown', e => { if (e.key === 'Escape') { VC.closeCart(); VC.closeMenu(); } });
    this.heroCycle();
    this.reveals();
  }
};
document.addEventListener('DOMContentLoaded', () => VC.init());
